module.exports = __webpack_public_path__ + "static/media/telephone-icon-yellow.13307543.svg";